/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Team member entity.
 *
 * @type {Object}
 */
export const TEAM_MEMBER_ENTITY = {
	name: 'team_member',
	kind: 'root',
	baseURL: '/wc-bookings/v2/resources/team-members',
	label: __( 'Team Member', 'woocommerce-bookings' ),
	plural: __( 'Team Members', 'woocommerce-bookings' ),
	key: 'id',
	supportsPagination: true,
};
